import { FriendsImage } from '@/assets/icons'
import { Layout } from '@/pages/customer/layout'

export const Recruit = () => {
	return (
		<Layout title="Freunde werben Freunde">
			<div className="mt-2 lg:mt-3 gap-10 lg:gap-30 grow rounded-xl lg:rounded-[16px] px-3 py-4 lg:px-8 lg:py-10 bg-white flex flex-col items-center justify-between">
				<div className="flex flex-col items-center">
					<h1 className="text-secondary text-center max-lg:leading-[45px] text-[32px] lg:text-5xl italic">
						WEITEREMPFEHLEN LOHNT SICH!
					</h1>
					<img src={FriendsImage} className="mt-5 lg:mt-3 max-lg:size-[178px]" />
					<p className="mt-9 lg:w-10/12 mx-auto text-secondary/50 text-center font-medium lg:text-2xl">
						Mit deinem persönlichen Empfehlungs-Code (diesen findest du unter „Mein Profil“)
						erhalten deine Freundinnen und Freunde{' '}
						<span className="text-secondary underline font-extrabold">
							20% auf die erste Buchung*.
						</span>
					</p>
					<p className="mt-12 text-secondary/50 text-center lg:text-2xl font-medium">
						Auch deine Treue wird belohnt:
					</p>
					<p className="text-secondary/50 text-center lg:text-2xl font-medium">
						Jedes Mal, wenn dein Code 4 Mal eingelöst wurde, erhältst du dein
					</p>
					<p className="text-center text-secondary/50 lg:text-2xl font-medium">
						Regal{' '}
						<span className="text-secondary underline font-extrabold">für 4 Wochen mietfrei.</span>
					</p>
				</div>
				<p className="text-secondary/50 text-center lg:text-lg">
					*Dieses Angebot gilt nur für Neukunden. Die geworbene Person darf nicht im selben Haushalt
					mit der werbenden Person leben. Gültig bei Buchungen ab 2 Wochen. Wir behalten uns vor,
					Buchungen ohne Angaben von Gründen zu stornieren.
				</p>
			</div>
		</Layout>
	)
}
